/* eslint-disable react/prop-types */
import React from "react";

export const FacebookLogo = ({ onClick, className }) => {
	return (
		<svg
			className={className}
			onClick={onClick}
			width="50"
			height="50"
			viewBox="0 0 50 50"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z"
				fill="white"
			/>
			<mask
				id="mask0_9647_644"
				style={{ maskType: "alpha" }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="50"
				height="50"
			>
				<path
					d="M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_9647_644)">
				<path
					d="M43.75 0H6.25C2.80312 0 0 2.80312 0 6.25V43.75C0 47.1969 2.80312 50 6.25 50H25V32.8125H18.75V25H25V18.75C25 13.5719 29.1969 9.375 34.375 9.375H40.625V17.1875H37.5C35.775 17.1875 34.375 17.025 34.375 18.75V25H42.1875L39.0625 32.8125H34.375V50H43.75C47.1969 50 50 47.1969 50 43.75V6.25C50 2.80312 47.1969 0 43.75 0Z"
					fill="#1877F2"
				/>
			</g>
		</svg>
	);
};

// {
// 	<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
// 		<path
// 			d="M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z"
// 			fill="white"
// 		/>
// 		<mask id="mask0_9647_644" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="50" height="50">
// 			<path
// 				d="M50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25Z"
// 				fill="white"
// 			/>
// 		</mask>
// 		<g mask="url(#mask0_9647_644)">
// 			<path
// 				d="M43.75 0H6.25C2.80312 0 0 2.80312 0 6.25V43.75C0 47.1969 2.80312 50 6.25 50H25V32.8125H18.75V25H25V18.75C25 13.5719 29.1969 9.375 34.375 9.375H40.625V17.1875H37.5C35.775 17.1875 34.375 17.025 34.375 18.75V25H42.1875L39.0625 32.8125H34.375V50H43.75C47.1969 50 50 47.1969 50 43.75V6.25C50 2.80312 47.1969 0 43.75 0Z"
// 				fill="#1877F2"
// 			/>
// 		</g>
// 	</svg>;
// }
